import React, { useCallback } from 'react';
import AddGallery from '@wix/da-ds/pkg/Icons/24x24/AddGallery';
import { getStoredCallback, isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';
export const useHandleGalleryClick = (editor)=>{
    const handleClick = useCallback(()=>{
        const onSelectMedia = getStoredCallback(editor, 'onSelectMedia');
        onSelectMedia && onSelectMedia((deviations)=>{
            if (deviations.length > 0) {
                editor.chain().focus().daGalleryAddDeviations(deviations, false).run();
            }
        }, {
            selectionLimit: 24
        });
    }, [
        editor
    ]);
    return handleClick;
};
const Gallery = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    const handleClick = useHandleGalleryClick(editor);
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'gallery')) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        tooltipText: t('button.gallery.tooltip'),
        "aria-label": t('button.gallery.tooltip'),
        icon: AddGallery,
        onClick: handleClick
    });
};
Gallery.displayName = 'GalleryButton';
export default Gallery;

//# sourceMappingURL=Gallery.js.map